<template>
    <div>
        <h1 class="text-center">SOYNET</h1>
        <p class="text-center">
            <a href="https://soynet.io"> https://soynet.io </a>
        </p>
        <h3>Definitions</h3>
        <p>
            “Account” means an online account registered by you for the purpose
            of using the Services.
        </p>
        <p>
            “Model Market” means marketplace for SoyNet models available at
            website upon setting up an Account, that may include model
            management, benchmarking, optimization, deployment and serving, as
            may be updated by SOYNET from time to time.
        </p>
        <p>
            “Services” means the services available upon registering for the
            Model Market, and any applications, products, services,
            documentation, and software made available through the Model Market.
        </p>
        <p>
            “Third Party Products” means any service, products, software or
            application that is provided by a third party and interoperates with
            a Service.
        </p>
        <p>“We”, “Us”, “SOYNET” or “Our” means soynet.io and its affiliates.</p>
        <p>
            “You” or “Customer” means the company or other legal entity and its
            affiliates for which you are accepting these Terms.
        </p>
        <h3>Terms and Conditions</h3>
        <p>
            You can use our services under our legal terms, and they apply to
            you and the company you are using them for. See also our Privacy
            Policy.
        </p>
        <p>
            To use the service, you need to register an account, using accurate
            information. You can use the account for the benefit of your own
            company, but not to provide services to anyone else. Some of the
            models are available free of charge, and some are available for a
            fee. It depends on the custom requirements to suit the customers
            environment.
        </p>
        <p>
            Some of the services are fully SaaS, and some of the services
            require you to install software. You have a right to use such
            software, in order to use our services.
        </p>
        <p>. Don’t use the same user for more than one person.</p>
        <p>
            Protect your login credentials. We cannot protect your account
            against unauthorized access that uses your correct login
            credentials. If you become aware that your login credentials are
            stolen or being used by a third party, you must immediately notify
            us and follow our guidance.
        </p>
        <p>
            We have a right to use material you upload to your account in order
            to provide you with our services We will only use your content to
            provide you with the services.
        </p>
        <p>
            Don’t use our proprietary services to compete with us or to try and
            build a similar service, by reverse engineering or otherwise.
        </p>
        <p>
            Don’t undermine our reputation or that of any other third parties or
            interfere with our business or any third parties.
        </p>
        <p>
            Don’t infringe upon our rights or those of any other third parties,
            including copyright, portrait rights, and other intellectual
            property rights, or collecting, storing, disclosing, or posting the
            personal information of other members without our consent.
        </p>
        <p>
            Don’t use the service for the purpose of business, advertising,
            profit-making, politics, illegal election campaigns, etc., without
            our consent.
        </p>
        <p>
            We own all the rights in the service, except for your right to use
            them under these terms.
        </p>
        <p>
            If you provide us with feedback on the service, we can use that
            feedback freely.
        </p>
        <p>
            If we get sued because of your breach of these terms, you will
            defend us in that claim. It is your responsibility to examine the
            suitability of the services to your needs. We do not guarantee
            anything with regard to the service and you use it at your own risk.
        </p>
        <p>You cannot claim any indirect damages from us.</p>
        <p>Any paid services will terminate when your subscription expires.</p>
        <p>
            You can delete your account at any time by contacting
            support@soynet.io. All the data stored on that account in the
            service will be deleted, except if we need to keep it for legal
            reasons.
        </p>
        <p>
            You can stop using the services any time. We can terminate your
            access to the service if you do not comply with these terms. When
            the agreement terminates you will not have access to your account.
        </p>
        <p>
            These terms are subject to the laws of Republic of Korea and claims
            against us under these terms should be filed in Republic of Korea.
        </p>
        <p>
            We may list you as a user or issue a case study and use your logo in
            this context.
        </p>
        <p>
            We can change these terms by posting the updated version on our
            website.
        </p>
        <p>
            If a portion of these terms cannot be legally enforced, other
            portions will not be affected.
        </p>
        <p>Any waiver of a right under these terms should be in writing.</p>
        <p>
            We(SOYNET) and you are two separate entities entering into a
            contract.
        </p>
        <p>
            Only your company has the right to use the account. You cannot
            transfer the account or any rights under these terms to anyone else.
        </p>
        <p>No one who is not a party to this agreement can enforce it.</p>
        <p>
            <span class="text-decoration-underline fst-italic"
                >Contact Us.</span
            >
            For any questions about these Terms or any other issue regarding
            SOYNET or the Services please contact us at:
            <a href="mailto:support@soynet.io">support@soynet.io</a>
        </p>
        <p>
            These terms of service, together with any other agreements or terms
            incorporated by reference, including our Privacy Policy (the “Terms
            “) govern your use of the Services. These Terms constitute a binding
            and enforceable legal contract between SOYNET and You. By accepting
            these Terms electronically by clicking a box indicating your
            acceptance, or by using the Services, you agree to these Terms. If
            you are entering into these Terms on behalf of a company or another
            legal entity, you represent that you have the authority to bind such
            entity and its affiliates to these Terms, in which case the term
            “You” will refer to such entity and its affiliates. If the legal
            entity that you represent does not agree with these Terms, you must
            not accept these Terms or use the Services.
        </p>
        <h2 class="text-center">End User license and Agreement</h2>
        <p>
            <span class="fw-bold">Registration.</span>
            Following the initial registration of an Account you will have the
            ability to access the Model Market and use the Services available
            thereon in connection with your Data solely for the purpose of your
            internal business needs. We may update the Model Market from time to
            time, including adding or removing features and policies. Some of
            the Services may be made available subject to applicable fees, as
            determined by SOYNET from time to time.
        </p>
        <p>
            <span class="fw-bold">Software.</span>
            Some Services may require you to download and locally install
            software. Such software shall be considered part of the Model Market
            for the purposes hereof, and all limitations imposed on you
            hereunder in connection with the Model Market shall apply to such
            software. You are hereby granted a limited, revocable,
            non-sublicensable, non-transferable license during the Term to use
            such software solely as required in connection with the Services. If
            any software is offered under an open-source license, we will make
            the license available to you and the provisions of that license
            shall apply notwithstanding any provisions to the contrary under
            these Terms.
        </p>
        <p>
            <span class="fw-bold">Account Information.</span>
            You must safeguard your Account and not disclose, and procure that
            Authorized Users not disclose, the login information associated with
            the Account. You must provide us with accurate and complete
            information in order to create an Account, including information of
            Authorized Users. You agree to keep your Account information up to
            date and accurate, including with regard to Authorized Users.
        </p>
        <p>
            YOU ARE SOLELY AND FULLY RESPONSIBLE FOR MAINTAINING THE
            CONFIDENTIALITY OF THE ACCOUNT USERNAMES AND PASSWORDS. YOU ARE
            SOLELY AND FULLY RESPONSIBLE FOR ALL ACTIVITIES THAT OCCUR UNDER THE
            ACCOUNT. You must notify us immediately of any unauthorized use of
            your Account or any other breach of security.
        </p>
        <p>
            <span class="fw-bold">Deletion of Account.</span>
            You may delete your Account at any time by sending an email to
            support@soynet.io requesting such deletion. Any Data and other
            information and data you entered into the Model Market may be
            permanently deleted if you delete the Account, provided we may
            retain certain information as required to comply with our legal
            obligations, resolve disputes and enforce our agreements (unless we
            are instructed otherwise).
        </p>
        <p>
            <span class="fw-bold">Model License per GPU.</span>
            Subject to the terms herein, SOYNET hereby grants you a limited,
            personal, non-exclusive, non-transferable, non-sublicensable right
            to use the downloaded models on one GPU generated based on GPU Id
            during the Term. You shall be solely responsible to ensure that the
            Models downloaded from Model Market is properly installed and used,
            and is permanently deleted by you at the expiration of the Term,
            which for community tier users is not limited.
        </p>
        <p>
            <span class="fw-bold">General Model License.</span>
            Subject to the terms herein, SOYNET hereby grants you a limited,
            personal, non-exclusive, non-transferable, non-sub-licensable right
            to use SOYNET’s models made available through the Model Market
            during the period subscription is vali subject to the license terms
            set forth in the Model Market.
        </p>
        <p>
            <span class="fw-bold">Title & Ownership.</span>
            The Model in Model Market is an intellectual property of SOYNET. The
            parties further acknowledge and agree that the use of the Model by
            the Customer requires a valid subscription of the Model Market and
            license to GPU Id. Neither party will permit any unauthorized User
            or any third party, to directly or indirectly copy, transmit,
            distribute, sell, transfer, modify, adapt, enhance, translate,
            reverse engineer, disassemble, decompile, attempt to derive source
            code, or create derivative works from the Model from Model Market or
            any source code or components thereof except in connection with the
            performance of this Agreement.
        </p>
        <p>
            <span class="fw-bold">Obligations.</span>
            You agree to do each of the following in connection with your use of
            the Services: (i) comply with all applicable laws, rules and
            regulations, including those regarding data privacy, intellectual
            property rights and export control; (ii) use the Services only for
            the purpose of using the Services for your own internal business
            purpose, and only during the Term; (iii) use reasonable security
            precautions for providing access to the Services by your Authorized
            Users, customers or other individuals to whom You provide access.
        </p>
        <p>
            <span class="fw-bold">Restrictions.</span>
            You must not misuse the Services. For example, you may not, whether
            by yourself or anyone on your behalf (a) sell, resell, or lease the
            Model Market or access or attempt to access the Services by any
            means other than the interface we provided or authorized; (b)
            circumvent any access or use restrictions put into place to prevent
            certain uses of the Services;(c) attempt to disable, impair, or
            destroy the Services, or Model Market; (d)reverse engineer or
            decompile the Services, attempt to do so, or assist anyone in doing
            so; or (e) use the Service for any benchmarking or competitive
            purposes.
        </p>
        <p>
            <span class="fw-bold">Compensation.</span>
            Compensation for damages due to a solution error cannot exceed the
            amount of the contract currently concluded.
        </p>
        <p>
            The user cannot claim compensation for damages caused by errors in
            the use of the solution, and the user must prove the error of the
            solution at his/her own expense.
        </p>
        <p>
            SOYNET uses drivers and APIs provided by hardware vendors such as
            CUDA, cuDNN, TensorRT, etc. and SOYNET is not responsible for
            damages incurred from flaws of them.
        </p>
        <p>
            <span class="fw-bold">Refund:</span>
            Refund is only valid for Standard and Enterprise subscriptions. If
            the user has purchased a model and generated license key for the
            same it is not valid for refund.
        </p>
        <p>
            Refund is valid only in case the model is purchases by mistake and
            no license key is generated.
        </p>
        <p>
            <span class="fw-bold">Changes to Terms.</span>
            SOYNET may change the Terms from time to time. You are responsible
            for checking the website regularly for such changes. By continuing
            to access or using the Services you agree to be bound by the revised
            Terms.
        </p>
        <p>
            <span class="fw-bold">Severability.</span>
            If any part of these Terms is deemed unlawful, void or for any
            reason unenforceable, then that provision shall be deemed to be
            severable from the rest of these Terms and shall not affect the
            validity and enforceability of any of the remaining provisions of
            these Terms. In such cases, the part deemed invalid or unenforceable
            shall be construed in a manner consistent with applicable law to
            reflect, as closely as possible, the original intent of the parties.
        </p>
        <p>
            <span class="fw-bold">Waiver.</span>
            No waiver by us of a breach of any of the provisions of terms of
            these Terms shall be construed as a waiver of any preceding or
            succeeding breach of any of the provisions of these Terms.
        </p>
        <p>
            <span class="fw-bold">Relationship.</span>
            Nothing in these Terms shall be construed as creating any agency,
            partnership, trust arrangement, fiduciary relationship or any other
            form of joint enterprise between you and SOYNET.
        </p>
        <p>
            <span class="fw-bold">Entire Agreement.</span>
            These Terms contain the entire agreement between SOYNET and You
            relating to your use of the Services and supersedes any and all
            prior agreements between SOYNET and You in relation to the same. You
            confirm that, in agreeing to accept these Terms, you have not relied
            on any representation except as has expressly been made by SOYNET in
            these Terms.
        </p>
        <p>
            <span class="fw-bold">Assignment.</span>
            You may not assign your rights or delegate your obligations under
            these Terms without SOYNET’s prior written consent. Any purported
            assignment contrary to this section will be null and void. SOYNET
            may assign its obligations hereunder among the various SOYNET
            entities within the SOYNET Inc. group, by a change to the definition
            of SOYNET hereunder which change will become effective upon posting
            on the Model Market.
        </p>
        <p>
            <span class="fw-bold">No Third-Party Rights.</span>
            There are no third-party beneficiaries to these Terms. Without
            limiting this section, Authorized users are not third-party
            beneficiaries to your rights under these Terms.
        </p>
        <p>
            <span class="fw-bold">Retention of Rights.</span>
            All rights not expressly granted to You under these Terms are
            reserved by SOYNET. We reserve all rights, title and interest to the
            Services, the Model Market and any of their related intellectual
            property rights. The Terms do not convey to You an interest in or to
            SOYNET’s intellectual property rights. Nothing in the Terms
            constitutes a waiver of SOYNET’s Intellectual Property Rights under
            any law.
        </p>
        <p>
            <span class="fw-bold">Feedback.</span>
            To the extent You provide us with any feedback, comments or
            suggestions (“Feedback “), you grant us a royalty-free, fully paid
            up, worldwide, perpetual and irrevocable license to incorporate the
            Feedback into the Services or any of our current or future products
            or services.
        </p>
        <p>
            <span class="fw-bold">Indemnification.</span>
            You will indemnify, defend, and hold harmless SOYNET, its
            affiliates, resellers, employees and agents (the “Indemnified
            Parties“) from and against all liabilities, damages, and costs
            (including reasonable attorneys’ fees) arising out of any claim,
            demand, suit or proceeding by a third party alleging that your Data
            or your use of the Services infringes or misappropriates a third
            party’s intellectual property rights or privacy rights, violates
            applicable law or that your use of the Services is in violation of
            these Terms.
        </p>
        <p>
            <span class="fw-bold">Disclaimers of Warranties.</span>
            THE SERVICES ARE PROVIDED ON AN “AS IS”, AND “AS AVAILABLE” BASIS,
            AND SOYNET DISCLAIMS ALL WARRANTIES OF ANY KIND, EXPRESS, IMPLIED OR
            STATUTORY, INCLUDING BUT NOT LIMITED TO RELIABILITY OF SERVICE,
            WARRANTIES OF NON-INFRINGEMENT OR IMPLIED WARRANTIES OF USE,
            MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR USE. WE
            DISCLAIM ALL LIABILITIES AND ANY OBLIGATIONS FOR ANY HARM OR DAMAGE
            CAUSED BY ANY THIRD-PARTY HOSTING PROVIDERS. WE DO NOT WARRANT THAT
            THE SERVICES WILL BE UNINTERRUPTED, WITHOUT ERROR, OR FREE OF
            DEFECTS.
        </p>
        <h3>Limitation of Liability</h3>
        <p>
            IN NO EVENT WILL SOYNET BE LIABLE FOR (I) INCIDENTAL, SPECIAL,
            INDIRECT, OR CONSEQUENTIAL DAMAGES OR (II) LOSS OF PROFITS OR
            REVENUE, LOSS OF DATA, BUSINESS INTERRUPTION, OR LOSS OF GOODWILL,
            IN EACH CASE ARISING OUT OF OR RELATED TO YOUR USE OR INABILITY TO
            USE THE SERVICES, HOWEVER CAUSED, REGARDLESS OF THE THEORY OF
            LIABILITY (CONTRACT, TORT, OR OTHERWISE) AND EVEN IF SOYNET HAS BEEN
            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
        </p>
        <p>
            IN NO EVENT WILL SOYNET’S TOTAL LIABILITY TO YOU FOR ALL DAMAGES
            ARISING OUT OF OR RELATED TO THESE TERMS OR TO THE SERVICES EXCEED
            AN AMOUNT OF US$100.00.
        </p>
        <p>
            We shall not be liable for any damages incurred in relation to the
            following reasons or other reasons specified in these Terms.
        </p>
        <p>
            (a) The Service cannot be provided due to a force majeure event
            equivalent to natural disasters or national policies, etc.
        </p>
        <p>
            (b) The Service has been suspended or a complication has been caused
            by reasons attributable to you
        </p>
        <p>
            (c) Our key telecommunications service provider suspends or fails to
            provide normal telecommunication services due to any reasons not
            attributable to us
        </p>
        <p>
            (d) A third party illegally accesses or uses our server, interferes
            with the transmission of data to or from our Server, or transmits or
            introduces malicious programs to our server
        </p>
        <p>
            (e) The damage is caused by the omission, exclusion, destruction of
            data without any causes attributable to us
        </p>
        <p>
            (f) The service is provided by us for free; however, this is limited
            to the extent that there are no related provisions under applicable
            law
        </p>
        <p>
            (g) The damage is caused by inaccurate or unreliable information or
            materials provided by you regarding the Services
        </p>
        <p>
            (h) The damage is caused due to reasons other than our intentional
            misconduct or negligence
        </p>
        <p>THESE LIMITATIONS WILL NOT APPLY TO THE EXTENT PROHIBITED BY LAW.</p>
        <p>
            <span class="fw-bold">Term.</span>
            These Terms commence on the date you first accept them and will
            remain in effect until these Terms are terminated or you delete your
            Account, whichever occurs first. Notwithstanding, if any Services
            hereunder are subject to a fee, the Term shall be deemed to expire
            in connection with such Services upon the expiration of your
            subscription term.
        </p>
        <p>
            <span class="fw-bold">Termination.</span>
            You may stop using the Services at any time and you may delete your
            Account. We may suspend or terminate your access to the License and
            Services at any time at our discretion and without notice if You do
            not comply with these Terms. Upon termination of the License and
            Services to You, the Account will be terminated, and from the date
            of termination You will no longer be able to access your Account.
        </p>
        <p>
            <span class="fw-bold">Survival.</span>
            The provisions of these Terms that, by their nature and content,
            must survive the termination of these Terms in order to achieve the
            fundamental purposes of these Terms shall so survive. Without
            limiting the generality of the foregoing, the Intellectual Property
            Rights, Disclaimers of Warranties, Limitation of Liability,
            Governing Law and Jurisdiction and General sections, will survive
            the termination or expiration of the Terms.
        </p>
        <p>
            <span class="fw-bold">Governing Law and Jurisdiction.</span>
            These Terms are governed by the laws of the state of Republic of
            Korea excluding rules as to choose and conflicts of law and the
            courts in the state of Republic of Korea will have jurisdiction;
            however, SOYNET or its Affiliate may bring suit for payment in the
            country where Your entity is located. You and SOYNET agree that the
            United Nations Convention on Contracts for the International Sale of
            Goods will not apply.
        </p>
        <p>
            <span class="fw-bold">Publicity.</span>
            We may issue publicity or general marketing communications
            concerning our involvement with You, including listing You as a user
            of our Model Market on our website and/or publishing a case study,
            and You grant us a license to use your logo in connection with such
            publication and agree to reasonably cooperate with and contribute to
            such case study.
        </p>
        <p>
            <span class="fw-bold">Contact Us.</span>
            For any questions about these Terms or any other issue regarding
            SOYNET or the Services please contact us at:
            <a href="mailto:support@soynet.io">support@soynet.io</a>
        </p>
    </div>
</template>
<style scoped></style>
<script>
export default {};
</script>
